import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=0119e606&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=js"
export * from "./Configuration.vue?vue&type=script&lang=js"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=0119e606&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119e606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0119e606')) {
      api.createRecord('0119e606', component.options)
    } else {
      api.reload('0119e606', component.options)
    }
    module.hot.accept("./Configuration.vue?vue&type=template&id=0119e606&scoped=true", function () {
      api.rerender('0119e606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/Configuration.vue"
export default component.exports